// extracted by mini-css-extract-plugin
module.exports = {"layout":"_2lELW__layout","header":"_12ccg__header","headerText":"_3owS1__headerText theme-accent-border","headerLink":"_3pzdk__headerLink"};